import { connect } from 'react-redux';
import { enterZoomMode, exitZoomMode } from '../DeviationPage/redux/actions';
import { getIsZoomed } from '../DeviationPage/redux/selectors';
import { getIsCurrentUserAuthorOf } from '../redux/deviations/selectors';
var mapStateToProps = function (state, _a) {
    var deviation = _a.deviation;
    return ({
        isZoomed: getIsZoomed(state),
        isOwner: getIsCurrentUserAuthorOf(state, deviation),
    });
};
var mapDispatchToProps = {
    onEnterZoomMode: enterZoomMode,
    onExitZoomMode: exitZoomMode,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ArtStage.container.js.map